<template>
  <modal-pasien-create ref="modalPasienCreate" type="update" @refreshData="refreshData" />
</template>

<script>
import ModalPasienCreate from '@/components/pasien/ModalPasienCreate.vue'
export default {
  name: 'ModalPasienUpdate',
  components: {
    ModalPasienCreate
  },
  methods: {
    refreshData() {
      this.$emit('refreshData')
    },
    async openModal(pasienData) {
      // Check if modal is already visible to prevent duplicates
      const modalElement = document.getElementById('modal-pasien-update')
      if (modalElement && modalElement.classList.contains('show')) {
        return
      }

      // Set the patient data to the Vuex store using the UPDATE_FORM_EDIT mutation
      if (pasienData) {
        this.$store.commit('pasien/UPDATE_FORM_EDIT', { ...pasienData })
      }

      // Show the modal using the static unique modal ID
      this.$bvModal.show('modal-pasien-update')
    }
  }
}
</script>